<template>
  <el-dialog
    :visible.sync="dialog"
    width="950px"
    center
    :before-close="handleClose"
    custom-class="my-dialog"
  >
 <div class="ReactModal__Content ReactModal__Content--after-open pano-modal-main WarningModal_modal_u48Qn4" tabindex="-1" role="dialog" aria-label="modal">
     <div class="pano-modal-header">操作确认</div>
     <!-- <div class="pano-modal-body">
         <div class="WarningModal_warning_qTPb3x">
             <img src="data:image/png;base64,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" class="WarningModal_img_2bWrGD"><div class="WarningModal_warningTitle_24i5_o">该操作会清空相应内容</div><div class="WarningModal_tip_2EsHEF">因当前场景没有设置过内容，把空内容应用到其它场景会清空其它场景相应的内容，是否继续？</div></div>
    </div> -->
   <div class="pano-modal-body">
       <div style="position: relative; overflow: hidden; width: 100%; height: 495px;">
           <div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; overflow: scroll; margin-right: -17px; margin-bottom: -17px;">
               <div class="ScenesSelectModal_body_1db5-e">
                   <div class="ScenesSelectModal_group_1y_Y4c">
                       <div class="ScenesSelectModal_groupTitle_3XeQZE">
                           <div class="Checkbox_container_jYKPxJ">
                               <div @click='changeAllCheck' :class="{'Checkbox_checkbox_2hIu2H':true,'Checkbox_checked_3yFHX3':allcheck}" style="width: 14px; height: 14px;">
                                   <span data-v-da99e756="" class="SVGInline"><svg data-v-da99e756="" fill="#fff" width="8" height="7" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg" class="SVGInline-svg" style="width: 10px; height: 10px;"><path data-v-da99e756="" d="M7.146 0l-4.36 4.39L.81 2.412 0 3.371l2.757 2.756L8 .854z" fill-rule="evenodd"></path></svg></span>
                               </div>
                               <div class="Checkbox_label_3AqBz_">
                                   <div class="MaxWidthText_ellipsis_3dq6uh" style="max-width: 880px;color:black">场景选择</div></div></div></div>
                                   <div class="ScenesSelectModal_list_3JykoI">
                                               <div class="ScenesSelectModal_item_1HUY34" v-for='(item,i) in arr' :key='i' @click='chooseItem(i)'>
                                                    <div :class="{'ScenesSelectModal_thumb_3fMuQe':true,'active':item.ischeck}">
                                                    <div :style="{'width': '100%', 'height': '100%', 'background-image': 'url('+item.url+')', 'background-repeat': 'no-repeat', 'background-size': 'cover', 'background-position': 'center center'}"></div></div>
                                                    <div class="MaxWidthText_ellipsis_3dq6uh ScenesSelectModal_name_2mjeGp">c05</div>
                                               </div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               <div style="width: 94px; height: 0px;"></div>
                                               </div></div></div></div><div style="position: absolute; height: 6px; right: 2px; bottom: 2px; left: 2px; border-radius: 3px;">
                                                   <div style="position: relative; display: block; height: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); width: 0px;"></div></div>
                                                   <div style="position: absolute; width: 6px; right: 2px; bottom: 2px; top: 2px; border-radius: 3px;">
                                                       <div style="position: relative; display: block; width: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); height: 0px;"></div>
                                                       </div></div>
     </div>
             <!-- <div class="pano-modal-footer">
                 <div class="WarningModal_btns_ye5uuP">
                     <a class="pano-button pano-button-md pano-button-gray WarningModal_btn_nkUu3j">继续清空</a>
                     <a class="pano-button pano-button-md pano-button-important WarningModal_btn_nkUu3j" @click='closealert'>我再想想</a></div>
            </div> -->
            <div class="pano-modal-footer">
                <div class="ScenesSelectModal_footer_kL9Mp1">
                    <div class="ScenesSelectModal_all_3B8BLR">
                        <div class="Checkbox_container_jYKPxJ">
                            <div @click='changeAllCheck' :class="{'Checkbox_checkbox_2hIu2H':true,'Checkbox_checked_3yFHX3':allcheck}" style="width: 14px; height: 14px;">
                                <span class="SVGInline"><svg class="SVGInline-svg" fill="#fff" style="width: 10px;height: 10px;" width="8" height="7" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg"><path d="M7.146 0l-4.36 4.39L.81 2.412 0 3.371l2.757 2.756L8 .854z" fill-rule="evenodd"></path></svg></span></div><div class="Checkbox_label_3AqBz_" style='color:black'>全选</div></div></div>
                                <a @click='confirm' :class="{'pano-button':true,'pano-button-md':true,'pano-button-important':true,'ScenesSelectModal_confirmBtn_2Qd-c6':true,'pano-button-disabled':isdiable}" :disabled='isdiable'>确 定</a>
                                </div>
            </div>
       </div>
  </el-dialog>
</template>
<style scoped>
.pano-button-disabled, .pano-button-disabled:hover {
    background-color: #d8d8d8!important;
    color: #fff!important;
    border: 1px solid #d8d8d8;
    cursor: not-allowed!important;
}
.ScenesSelectModal_footer_kL9Mp1 {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.ScenesSelectModal_all_3B8BLR {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 30px;
}
.ScenesSelectModal_confirmBtn_2Qd-c6 {
    width: 120px;
}
.active{
    outline: rgb(255, 189, 16) solid 2px; outline-offset: -2px;
}
.ScenesSelectModal_body_1db5-e {
    padding: 20px 30px;
}
.ScenesSelectModal_group_1y_Y4c {
    margin-bottom: 20px;
}
.ScenesSelectModal_groupTitle_3XeQZE {
    padding-left: 5px;
    height: 15px;
}
.Checkbox_checkbox_2hIu2H, .Checkbox_container_jYKPxJ {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.Checkbox_container_jYKPxJ {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
}
.Checkbox_checkbox_2hIu2H {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background-color: #fff;
    border: 1px solid #d8d8d8;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.Checkbox_label_3AqBz_ {
    margin-left: 5px;
    cursor: pointer;
}
.MaxWidthText_ellipsis_3dq6uh {
    display: inlint-block;
    white-space: nowrap;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    overflow: hidden;
}
.ScenesSelectModal_list_3JykoI {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}
.ScenesSelectModal_item_1HUY34 {
    width: 84px;
    margin: 10px 5px 0;
    cursor: pointer;
}
.ScenesSelectModal_thumb_3fMuQe {
    height: 84px;
    margin-bottom: 8px;
}
.ScenesSelectModal_name_2mjeGp {
    text-align: center;
    font-size: 12px;
    line-height: 16px;
}
.my-dialog{
  z-index:10000;
  color: black;
}
.my-dialog.el-dialog--center .el-dialog__body {
  padding: 0 0 10px 0;
}

/* .my-dialog .el-dialog__header {
  padding: 0;
} */

.my-dialog .el-dialog__headerbtn {
  top: 7px;
  right: 7px;
  z-index: 10;
}
.el-pager .number{
 color: black;
}
</style>
<style scoped>
.pano-modal-footer {
    border-top: 1px solid #e9e9e9;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 65px;
}
.WarningModal_btns_ye5uuP {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 260px;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}
.WarningModal_btn_nkUu3j {
    width: 120px;
}
.pano-button-md {
    height: 34px;
}
.pano-button-important {
    background-color: #db4437;
    color: #fff;
}
.pano-button {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 30px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 3px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
}
.pano-button-gray {
    background-color: rgba(0,0,0,0);
    color: #4a4a4a;
    border: 1px solid #c4c4c4;
}
.el-dialog__header{
    padding:0
}
.WarningModal_modal_u48Qn4 {
    width: 950px;
    height: 620px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.pano-modal-header {
    /* width: 100%; */
    position: relative;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 60px;
    padding: 0 20px;
    border-radius: 6px 6px 0 0;
    font-size: 20px;
    border-bottom: 1px solid #e9e9e9;
    display: flex;
    color:black
}
.pano-modal-body {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 auto;
    flex: 1 auto;
}
.WarningModal_warning_qTPb3x {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    line-height: 1.4;
    text-align: center;
}
.WarningModal_img_2bWrGD {
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
}
.WarningModal_warningTitle_24i5_o {
    font-size: 18px;
    color: #5c5c5c;
}
.WarningModal_tip_2EsHEF {
    width: 400px;
    color: #7a7a7a;
}
.pano-modal-body {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 auto;
    flex: 1 auto;
}
.pano-header {
  height: 60px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 20px;
  font-size: 20px;
  border-bottom: 1px solid #e9e9e9;
}

.title {
  margin-right: 20px;
  font-size: 16px;
  font-weight: 700;
  color: black;
}

.select {
  flex: 1 auto;
}

.input-with-select {
  width: 200px;
}

.upload-block {
  font-size: 14px;
}

.pano-model-body {
  position: relative;
  flex: 1 auto;
}

.title-line {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  background-color: #f3f3f3;
  border-bottom: 1px solid #e9e9e9;
}

.title-line-left {
  display: flex;
  align-items: center;
}
.all-word {
  color: black;
}

.checkbox-block {
  margin-right: 10px;
}

.checkbox {
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  color: white!important;
}

.checkbox.active {
  background-color: #427afb;
  border-color: #427afb;
}

.list {
  height: 435px;
}

.list-li {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 40px;
  border-bottom: 1px solid #e9e9e9;
}

.middle {
  display: flex;
  flex: 1 auto;
  align-items: center;
}

.img-block {
  width: 30px;
  height: 30px;
  background-color: #ddd;
  cursor: pointer;
}

.img-block img {
  width: 100%;
  height: 100%;
}

.li-title {
  max-width: 500px;

  margin-left: 10px;
  line-height: 30px;
  font-size: 12px;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  color: black;
}

.date {
  font-size: 12px;
  color: #9b9b9b;
}

.page-block {
  display: flex;
  justify-content: center;
}
</style>
<script>
import https from '../https.js'
import Upload from '../components/upload.vue'
export default {
  name: '',
  props: {
    infos: Object,
    closeAlert: Function
  },
  components: {
    Upload: Upload
  },

  data() {
    return {
      dialog: true,
      searchTxt: '',
      allcheck: false,
      page: {
        currentPage: 1,
        total: 0
      },
      chooseArr: [],
      isdiable: true,
      arr: [
        // {
        //   id: "44901c67-81c4-4f30-8fea-c1d0dfc1927b",
        //   fileName: "weixin_code.png",
        //   filePath: "/Attached/2020/6/17/weixin_code.png",
        //   fileFormat: ".png",
        //   hashValue: "2020617135921",
        //   fileSize: 11917,
        //   type: null,
        //   status: 1,
        //   createTime: "2020-06-17T13:59:21.487",
        //   thumbnailUrl: null
        // }
      ]
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  methods: {
    confirm() {
      if(this.chooseArr.length > 0) {
        console.log(this.chooseArr)
        this.$parent.renewInfos(this.chooseArr)
        this.closeAlert()
      }
    },
    getChooseArr() {
      this.chooseArr = []
      for(var i = 0; i < this.arr.length; i++) {
        if(this.arr[i].ischeck == true) {
          this.chooseArr.push(this.arr[i])
        }
      }
      if(this.chooseArr.length == 0) {
        this.isdiable = true
      } else{
        this.isdiable = false
      }
    },
    changeAllCheck() {
      this.allcheck = !this.allcheck

      if(this.allcheck == true) {
        for(var i = 0; i < this.arr.length; i++) {
          this.arr[i].ischeck = true
        }
      } else{
        for(var i = 0; i < this.arr.length; i++) {
          this.arr[i].ischeck = false
        }
      }
      this.getChooseArr()
    },
    closealert() {
      this.closeAlert()
    },
    chooseItem(i) {
      this.arr[i].ischeck = !this.arr[i].ischeck
      this.getChooseArr()
    },
    init() {
      for(var i = 0; i < this.infos.panos.length; i++) {
        var a = { ischeck: false, id: this.infos.panos[i].id, name: this.infos.panos[i].physicalFile.fileName, url: this.infos.panos[i].physicalFile.thumbnailUrl }
        this.arr.push(a)
      }
    },
    handleCurrentChange(val) {
      this.allcheck = false
      this.chooseArr = []
      this.page.currentPage = val
      this.init()
    },

    choose(id) {
      this.chooseArr = []
      for (let i = 0; i < this.arr.length; i++) {
        this.arr[i].check = false
        if (this.arr[i].id === id) {
          const isCheck = this.arr[i].check || false
          if (isCheck) {
            this.arr[i].check = false
          } else {
            console.log(isCheck)
            this.arr[i].check = true
            console.log(this.arr)
            this.chooseArr.push(this.arr[i])
          }
        } else {
          if (this.arr[i].check) {
            this.chooseArr.push(this.arr[i])
          }
        }
      }
      if (this.chooseArr.length === 8) {
        this.allcheck = true
      } else {
        this.allcheck = false
      }
    },
    handleClose(done) {
      this.closeAlert()
    },
    uploadPic(data) {
      console.log(data)
      this.init()
    },
    submit() {
      this.submitFunc(this.chooseArr)
      this.closeFunc()
    }
  }
}
</script>
